export default __webpack_public_path__ + "static/media/4-3.7d1f1bfd.png";